import React, { useMemo, useState, useEffect, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { callOperation } from "async-ops";
import MdaeDataGrid, {
  IMdaeDataGridProps,
} from "../../../common_components/common_widgets/data-grid";
import MdaeActionPopover from "../../../common_components/common_widgets/menu-action-popover";
import { GET_AUDIT_LIST } from "./services/get-all-audits";
import { DELETE_EXTERNAL_AUDIT } from "./services/delete-external-audit";
import {
  SET_AUDIT_DATAGRID_FILTER,
  TOGGLE_AUDIT_LIST_ACTION_POPOVER,
  SET_HEADER_RANGE_FILTER_COUNT,
  TOGGLE_DOCUMENT_MANAGEMENT_POPUP,
  TOGGLE_VIEW_REPORT_POPUP,
  SET_LEVEL_GRID_SEARCH_ENABLED,
  SET_AUDIT_LIST,
  setDataGridFilter,
  resetDataGridFilter,
  GetInitialHeaderRangeCount,
} from "./reducers/audit-list-reducer";
import { first, isEqual } from "lodash";
import DataGridRecordsFilter from "../../../common_components/common_widgets/data-grid-records-filter/component";
import {
  FG_MANAGE_DELETED_AUDITS_CASES,
  getUserPermissionObject,
} from "../../../common_components/user-permissions-helper";
import { getDataGridActionEllipsisComponent } from "../../../common_components/common_widgets/data-grid-action-ellipsis";
import "./index.scss";
import DocumentManagementPopup from "./document-management-popup";
import {
  hasAnyFeatureGroupAccess,
} from "../../../common_components/user-permissions-helper";
import { compose } from "recompose";
import { withRouter } from "react-router";
import {
  HIDE_LOADER,
  SHOW_LOADER,
  TOGGLE_CONFIRMATION_POPUP,
} from "../../../common_components/mdae-common-reducer";
import $ from "jquery";
import ViewReport from "./view-report";
import MdaeTextBox from "../../../common_components/common_widgets/text-box";
import dxDataGrid from "devextreme/ui/data_grid";
import { MasterDetail } from "devextreme-react/data-grid";
import { CLAIM_TYPES } from "../../../common_components/case-search/constants";
import EACaseDetail from "../../../common_components/case-details/ea-case-list";
import CaseDetail from "../case-detail";
import Guid from "devextreme/core/guid";
import { AUDIT_LIST_TYPE } from "../../emdr-inbox/constant";
import { actions as asyncActions } from "async-ops";
import { GET_CODE_TYPES_LOOKUPS } from "../services/get-code-types-lookups";
import { GET_USER_TASK_STATUS_LIST } from "../../../common_components/user-task-list/services/get-user-task-status-list";

interface IAuditList {
  type?: string;
  history?: any;
  doumentId:any;
  hideCases?: boolean;
  selectionModeOverride?: "single" | "multiple";
}
export const deleteExternalAuditMessage =
  "Are you sure you want to delete this Payer Audit?";
let myAudit = false;
let auditstatus = "";
let isFromDashboardWidget = false;
export const deleteExternalAudit = (
  auditData,
  myAudit,
  headerRangeFilterCount,
  dispatch
) => {
  return new Promise<void>((resolve, reject) => {
    dispatch({ type: SHOW_LOADER });
    callOperation(DELETE_EXTERNAL_AUDIT, auditData)
      .then(function(response) {
        if (response.isDeleted) {
          refreshExternalAuditList(myAudit, headerRangeFilterCount,null,0,null, dispatch);
        }
        resolve();
      })
      .finally(() => {
        dispatch({ type: HIDE_LOADER });
      });
  });
};

export const refreshExternalAuditList = (
  myAudit,
  headerRangeFilterCount,
  type,
  documentId,
  auditListSearchText,
  dispatch
) => {
  dispatch({ type: SHOW_LOADER });
  return callOperation(GET_AUDIT_LIST, {
    myAudit,
    headerRangeFilterCount: headerRangeFilterCount,
    type: type,
    documentId: auditListSearchText ? 0 : documentId,
    auditListSearchCriteria: auditListSearchText,
  }).then((response) => {
    dispatch({
      type: SET_AUDIT_LIST,
      data: {
        auditList: response,
      },
    });
  }).finally(() =>{
    dispatch({ type: HIDE_LOADER });
  })
};

interface IrenderToolbarButtonTemplate{

}
const RenderToolbarButtonTemplate:React.FC<IrenderToolbarButtonTemplate> = () => {
  const dispatch = useDispatch();
  const auditListDataGridInstance = dxDataGrid.getInstance(
    $("#pnlAuditList") as any
  ) as dxDataGrid;
  const auditListSearchText = useSelector(
    (state: any) => state.auditListReducer.auditListSearchText,
    isEqual
  );
  const isCaseLevelGridSearchEnabled = useSelector(
    (state: any) => state.auditListReducer.isCaseLevelGridSearchEnabled,
    isEqual
  );

  useEffect(() => {
    if(isCaseLevelGridSearchEnabled && auditListSearchText){
      setTimeout(() => {
        const el = document.querySelector('.sys-data-grid-clear-filter-icon-container');
        if (el) {
          (el as HTMLElement).style.color = '#73B944';
        }
      }, 100);
    }
    if (!isCaseLevelGridSearchEnabled){
      dispatch({
        type: SET_LEVEL_GRID_SEARCH_ENABLED,
        data: {
          auditListSearchText: "",
        },
      });
    }
    if (isCaseLevelGridSearchEnabled)
      setTimeout(() => {
        auditListDataGridInstance.clearFilter();
      }, 500); // used this because clearfilter was getting called before loading of the gridState when switching from audit search tab to cases
  }, [isCaseLevelGridSearchEnabled]);

  const auditsTabOnClick = useCallback(() => {
    auditListDataGridInstance.clearFilter();
    dispatch({
      type: SET_LEVEL_GRID_SEARCH_ENABLED,
      data: {
        isCaseLevelGridSearchEnabled: false,
      },
    });
    dispatch({
      type: SET_LEVEL_GRID_SEARCH_ENABLED,
      data: {
        isAuditWithCasesFetched: false,
      },
    });
    dispatch({ type: SHOW_LOADER });
    callOperation(GET_AUDIT_LIST, {
      myAudit,
      headerRangeFilterCount: 12,
      type: "",
      documentId: 0,
      auditListSearchCriteria: auditListSearchText,
    })
      .then((response) => {
        dispatch({
          type: SET_AUDIT_LIST,
          data: {
            auditList: response,
          },
        });
      })
      .finally(() => {
        dispatch({ type: HIDE_LOADER });
      });
  }, [auditListDataGridInstance]);

  const casesTabOnClick = useCallback(() => {
    dispatch({
      type: SET_LEVEL_GRID_SEARCH_ENABLED,
      data: {
        isCaseLevelGridSearchEnabled: true,
      },
    });
    auditListDataGridInstance.clearFilter();
    dispatch({
      type: SET_LEVEL_GRID_SEARCH_ENABLED,
      data: {
        auditListSearchText: "",
      },
    });
  }, []);

  const searchBoxOnValueChanged = useCallback(
    (e) => {
      if (e.event) {
        dispatch({
          type: SET_LEVEL_GRID_SEARCH_ENABLED,
          data: {
            auditListSearchText: e.value,
          },
        });
        if (!isCaseLevelGridSearchEnabled)
          auditListDataGridInstance.searchByText(e.value);
      }
    },
    [isCaseLevelGridSearchEnabled, auditListDataGridInstance]
  );

  const searchButtonOnClick = useCallback(() => {
    if (isCaseLevelGridSearchEnabled && auditListSearchText) {
      dispatch({ type: SHOW_LOADER });
      callOperation(GET_AUDIT_LIST, {
        myAudit,
        headerRangeFilterCount: 12,
        type: AUDIT_LIST_TYPE.AUDIT_WITH_CASES,
        documentId: 0,
        auditListSearchCriteria: auditListSearchText,
      })
        .then((response) => {
          dispatch({
            type: SET_AUDIT_LIST,
            data: {
              auditList: response,
            },
          });
          dispatch({
            type: SET_LEVEL_GRID_SEARCH_ENABLED,
            data: {
              isAuditWithCasesFetched: true,
            },
          });
          auditListDataGridInstance.expandAll(-1);
        })
        .finally(() => {
          dispatch({ type: HIDE_LOADER });
        });
    } else if (!isCaseLevelGridSearchEnabled && auditListSearchText) {
      auditListDataGridInstance.clearFilter();
      auditListDataGridInstance.searchByText(auditListSearchText);
    } else auditListDataGridInstance.clearFilter();
  }, [isCaseLevelGridSearchEnabled, auditListSearchText, myAudit, auditListDataGridInstance]);

  const searchBoxOnEnterClicked = useCallback(
    (e) => {
      searchButtonOnClick();
    },
    [searchButtonOnClick]
  );

  return (
    <div style={{ display: "flex" }}>
      <div className={"audit-list-search-box-container"} style={{ width: 300 }}>
        <div style={{ marginBottom: "-1px" }}>
          <div
            onClick={auditsTabOnClick}
            className={`switch-box ${
              !isCaseLevelGridSearchEnabled ? "selected-box" : "unselected-box"
            }`}
            style={{
              borderRight: "0px",
            }}
          >
            Audits
          </div>
          <div
            className={`switch-box ${
              isCaseLevelGridSearchEnabled ? "selected-box" : "unselected-box"
            }`}
            style={{
              borderLeft: "0px",
            }}
            onClick={casesTabOnClick}
          >
            Cases
          </div>
        </div>

        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1, display: "flex" }}>
            <MdaeTextBox
              id={""}
              onEnterKey={searchBoxOnEnterClicked}
              placeholder={
                isCaseLevelGridSearchEnabled
                  ? "Search Cases..."
                  : "Search Audits..."
              }
              style={{ width: 280 }}
              value={auditListSearchText}
              valueChangeEvent="input"
              onValueChanged={searchBoxOnValueChanged}
            ></MdaeTextBox>
            <div
              style={{
                visibility: isCaseLevelGridSearchEnabled ? "visible" : "hidden",
              }}
              className={`dx-icon dx-icon-search audit-list-grid-search-icon application-section-primary-background-color pointer-cursor`}
              onClick={searchButtonOnClick}
            ></div>
          </div>
          <span
            style={{
              marginLeft: 12,
              alignSelf: "center",
              visibility: isCaseLevelGridSearchEnabled ? "visible" : "hidden",
            }}
            className="search-button application-section-primary-color"
            title={
              "Searches the following case fields in incomplete audits: Original Account Number, Account Number, Alt Case ID, Current Round Case ID, MRN, Patient Last Name, Payer Case ID."
            }
          >
            <i className="img-circle fa fa-info-circle audit-info-circle"></i>
          </span>
        </div>
      </div>
    </div>
  );
};

interface IrendereMDRToolbarButtonTemplate {

}

const RenderExpandCollpaseButtonTemplate: React.FC<IrendereMDRToolbarButtonTemplate> = () => {
  const auditListDataGridInstance = dxDataGrid.getInstance(
    $("#pnlAuditList") as any
  ) as dxDataGrid;
  const [isExpandAll, setIsExpandAll] = useState(true);

  const expandAllRows = useCallback(() => {
    auditListDataGridInstance.expandAll(-1);
  }, []);

  const collapseAllRows = useCallback(() => {
    auditListDataGridInstance.collapseAll(-1);
  }, []);

  const handleExpandCollapseToggle = useCallback(() => {
    const newState = !isExpandAll;
    setIsExpandAll(newState);
    if (newState) {
      expandAllRows();
    } else {
      collapseAllRows();
    }
  }, [isExpandAll, expandAllRows, collapseAllRows, setIsExpandAll]);

  return (
    <div className="expand-collapse-button">
      <div
        id="btnExpandCollapseAllAdjustments"
        role="primary"
        onClick={handleExpandCollapseToggle}
      >
        <i
          className={`fa ${
            isExpandAll ? "fa-angle-down" : "fa-angle-right"
          } expand-collapse-icon`}
        ></i>
        <span className="expand-collapse-label">
          {isExpandAll ? "Collapse All Audits" : "Expand All Audits"}
        </span>
      </div>
    </div>
  );
};
const RendereMDRToolbarButtonTemplate: React.FC<IrendereMDRToolbarButtonTemplate> = () => {
  const dispatch =useDispatch()
  const auditListDataGridInstance = dxDataGrid.getInstance(
    $("#pnlAuditList") as any
  ) as dxDataGrid;
  const auditListSearchText = useSelector(
    (state: any) => state.auditListReducer.auditListSearchText,
    isEqual
  );
  const headerRangeFilterCount = useSelector(
    (state) => state["auditListReducer"].headerRangeFilterCount
  );
  const documentId = useSelector(
    (state) => state["emdrInboxReducer"].documentId
  );

  const onCaseSearchBarClick = useCallback(() => {
    let caseListSearchText;
    if (auditListSearchText != null) {
      if (auditListSearchText.toLowerCase() === "professional") {
        caseListSearchText = CLAIM_TYPES.PROFESSIONAL;
      } else if (auditListSearchText.toLowerCase() === "hospital") {
        caseListSearchText = CLAIM_TYPES.HOSPITAL;
      } else {
        caseListSearchText = auditListSearchText;
      }
    }
    refreshExternalAuditList(
      false,
      headerRangeFilterCount,
      AUDIT_LIST_TYPE.EMDR_TYPE,
      caseListSearchText ? 0 : documentId,
      caseListSearchText,
      dispatch
    ).then(() => {
      dispatch(setDataGridFilter(auditListDataGridInstance));
    });
  }, [auditListSearchText, headerRangeFilterCount, documentId, auditListDataGridInstance, dispatch]);

  const filterAuditCaseList =useCallback((e) => {
    const filterText = e.value;
    dispatch({
      type: SET_LEVEL_GRID_SEARCH_ENABLED,
      data: {
        auditListSearchText: filterText
      },
    });
  },[]);

  const onSeachTextBoxKeyDown = useCallback((e) => {
    // Check if Enter key is pressed
    if (e.event.key === "Enter") {
      onCaseSearchBarClick();
    }
  }, [auditListSearchText, onCaseSearchBarClick]);

  return (
    <div className={"attach-audit-or-case-search-box-container"}>
      <MdaeTextBox
        id={""}
        placeholder={"Search..."}
        valueChangeEvent="input"
        value={auditListSearchText}
        onValueChanged={filterAuditCaseList}
        onKeyDown={onSeachTextBoxKeyDown}
      ></MdaeTextBox>
      <div
        className={
          "dx-icon dx-icon-search user-task-card-datagrid-search-icon application-section-primary-background-color"
        }
        onClick={onCaseSearchBarClick}
      ></div>
    </div>
  );
};
const AuditList: React.FC<IAuditList> = (props) => {
  const dispatch = useDispatch();
  const [auditListGridInstance, setAuditListGridInstance] = useState(null);
  const selectionAdjustingRef = useRef(false);
  const isReportPopupVisible = useSelector(
    (state) => state["auditListReducer"].isReportPopupVisible,
    isEqual
  );
  const headerRangeFilterCount = useSelector(
    (state) => state["auditListReducer"].headerRangeFilterCount,
    isEqual
  );
  const isDocumentManagementEnabled = useSelector(
    (state) => state["documentManagementReducer"].isDocumentManagementEnabled,
    isEqual
  );
  const auditList = useSelector((state) => state["auditListReducer"].auditList);
  myAudit = false;
  const currentUrlSearchParams = new URLSearchParams(
    window.location.href.split("?")[1]
  );
  for (let parameterPair of currentUrlSearchParams.entries() as any) {
    if (
      parameterPair[0] &&
      parameterPair[0].toLowerCase() === "myaudit" &&
      parameterPair[1].toLowerCase() === "true"
    ) {
      myAudit = true;
    }
    if (
      parameterPair[0] &&
      parameterPair[0].toLowerCase() === "auditstatus" &&
      parameterPair[1] &&
      parameterPair[1] !== ""
    ) {
      auditstatus = parameterPair[1];
    }
    if (
      parameterPair[0] &&
      parameterPair[0].toLowerCase() === "isfromdashboardwidget"
    ) {
      isFromDashboardWidget = true;
    }
  }

  useEffect(() => {
    refreshExternalAuditList(
      myAudit,
      GetInitialHeaderRangeCount(props.type),
      props.type,
      props.doumentId,
      null,
      dispatch
    );
  }, [window.location.href]);

  useEffect(() => {
    return () => {
      dispatch({
        type: SET_LEVEL_GRID_SEARCH_ENABLED,
        data: {
          isAuditWithCasesFetched: false,
        },
      });
    dispatch({
      type: SET_LEVEL_GRID_SEARCH_ENABLED,
      data: {
        isCaseLevelGridSearchEnabled: false,
      },
    });
    };
  }, []);

  useEffect(() => {
    if (props.type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE) {
      dispatch({
        type: SET_HEADER_RANGE_FILTER_COUNT,
        data: {
          headerRangeFilterCount: 6,
        },
      });
    } else {
      dispatch({
        type: SET_HEADER_RANGE_FILTER_COUNT,
        data: {
          headerRangeFilterCount: 12,
        },
      });
    }
  }, [props.type]);

  const toggleAuditListActionPopover = useCallback((isVisible, target) => {
    dispatch({
      type: TOGGLE_AUDIT_LIST_ACTION_POPOVER,
      data: {
        auditListDataGridActionPopoverTarget: target,
        isAuditListDataGridActionPopoverVisible: isVisible,
      },
    });
  }, []);

  useEffect(() =>{
    dispatch(asyncActions.asyncOperationStart(GET_CODE_TYPES_LOOKUPS, {eaAuditId: 0}));
    dispatch(asyncActions.asyncOperationStart(GET_USER_TASK_STATUS_LIST, {}));
  }, [])

  const currentUser = useSelector(
    (state: any) => state.mdaeNavigationBarReducer.currentUser,
    isEqual
  );

  const auditPermissions = getUserPermissionObject(
    "AUDIT||AUDIT_AUDIT||DOCUMENT_MANAGEMENT",
    currentUser
  );
  const hasAuditDeleteAccess = useMemo(
    () =>
      hasAnyFeatureGroupAccess([FG_MANAGE_DELETED_AUDITS_CASES], currentUser),
    [currentUser]
  );
  const getCurrentSelectedRowData: any = () => {
    return first(auditListGridInstance?.getSelectedRowsData());
  };
  const eaAuditRounds = useSelector(
    (state) => state["externalAuditReducer"].eaAuditRounds,
    isEqual
  );
  const isDocumentManagementPopupVisible = useSelector(
    (state) => state["auditListReducer"].isDocumentManagementPopupVisible,
    isEqual
  );
  const currentEaRoundId = eaAuditRounds && eaAuditRounds[0]?.eaRoundId;
  const auditGroupId = useSelector(
    (state: any) =>
      state.auditPropertiesReducer.auditPropertiesData?.auditGroupId,
    isEqual
  );
  const hideConfirmationPopup = useCallback(() => {
    dispatch({
      type: TOGGLE_CONFIRMATION_POPUP,
      data: {
        visible: false,
      },
    });
  }, []);
  const showConfirmationPopup = useCallback(
    (message) => {
      toggleAuditListActionPopover(false, null);
      dispatch({
        type: TOGGLE_CONFIRMATION_POPUP,
        data: {
          onConfirm: () => {
            toggleAuditListActionPopover(false, null);
            deleteExternalAudit(
              { ...getCurrentSelectedRowData(), myAudit },
              myAudit,
              headerRangeFilterCount,
              dispatch
            ).then(() => {
              hideConfirmationPopup();
            });
          },
          visible: true,
          confirmShown: true,
          declineShown: true,
          width: 380,
          height: 200,
          contentHtml: message,
          onDecline: hideConfirmationPopup,
        },
      });
    },
    [
      toggleAuditListActionPopover,
      deleteExternalAudit,
      getCurrentSelectedRowData,
      headerRangeFilterCount,
      myAudit,
      hideConfirmationPopup,
      dispatch,
    ]
  );

  const toggleConfirmationPopupVisible = useCallback(
    (isVisible, message) => {
      if (isVisible) {
        showConfirmationPopup(message);
      } else {
        hideConfirmationPopup();
      }
    },
    [showConfirmationPopup, hideConfirmationPopup]
  );

  const toggleDocumentManagementPopupVisible = useCallback(
    (isVisible, title, currentSelectedRowId) => {
      dispatch({
        type: TOGGLE_DOCUMENT_MANAGEMENT_POPUP,
        data: {
          isDocumentManagementPopupVisible: isVisible,
          documentManagementPopupTitle: title,
          currentSelectedRowId: currentSelectedRowId,
        },
      });
    },
    []
  );

  const onInitialized = useCallback((e) => {
    setAuditListGridInstance(e.component);
  }, []);

  const onDisposing = useCallback((e) => {
    setAuditListGridInstance(null);
  }, []);

  if (auditstatus && auditstatus != "" && auditListGridInstance) {
    auditListGridInstance.columnOption("auditStatus", "filterValues", [
      auditstatus,
    ]);
  }
  const isCaseLevelGridSearchEnabled = useSelector(
    (state: any) => state.auditListReducer.isCaseLevelGridSearchEnabled,
    isEqual
  );
  const isAuditWithCasesFetched = useSelector(
    (state: any) => state.auditListReducer.isAuditWithCasesFetched,
    isEqual
  );

  const auditListDataGridOptions = useMemo(() => {
    return getAuditListDataGridOptions(
      props,
      dispatch,
      headerRangeFilterCount,
      isFromDashboardWidget,
      toggleAuditListActionPopover,
      myAudit,
      auditList,
      onInitialized,
      onDisposing,
      selectionAdjustingRef
    );
  }, [myAudit, auditList]);

  const auditListActionPopoverMenuList = () => [
    {
      text: "Preview",
      visible: props.type !== "eMDR" && auditPermissions.hasReadAccess,
      icon: () => {
        return (
          <div
            style={{ height: "14px" }}
            className={"preview-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        props.history.push(
          "/externalaudit/audit?auditId=" +
            getCurrentSelectedRowData().eaAuditId
        );
      },
    },
    {
      text: "Documents",
      visible: props.type !== "eMDR" && isDocumentManagementEnabled,
      icon: () => {
        return <div style={{ height: "14px" }} className={"upload-icon"}></div>;
      },
      onClick: () => {
        toggleAuditListActionPopover(false, null);
        toggleDocumentManagementPopupVisible(
          true,
          "Documents - " + getCurrentSelectedRowData().auditTitle,
          getCurrentSelectedRowData().eaAuditId
        );
      },
    },
    {
      text: "View Reports",
      visible: props.type !== "eMDR" && auditPermissions.hasReportWriteAccess,
      icon: () => {
        return (
          <div
            style={{ height: "16px", fontSize: "18px" }}
            className={"reports-action-icon"}
          ></div>
        );
      },
      onClick: (e) => {
        dispatch({
          type: TOGGLE_AUDIT_LIST_ACTION_POPOVER,
          data: {
            isAuditListDataGridActionPopoverVisible: false,
          },
        });
        dispatch({
          type: TOGGLE_VIEW_REPORT_POPUP,
          data: {
            isReportPopupVisible: true,
          },
        });
      },
    },
    {
      text: "Delete",
      visible: props.type !== "eMDR" && hasAuditDeleteAccess,
      icon: () => {
        return (
          <div
            style={{ height: "16px" }}
            className={"delete-action-icon"}
          ></div>
        );
      },
      onClick: () => {
        toggleConfirmationPopupVisible(true, deleteExternalAuditMessage);
      },
    },
  ];
  const dataGridRecordsFilterFetchOptions = {
    reducerName: "auditListReducer",
    valueActionType: SET_HEADER_RANGE_FILTER_COUNT,
    fetchActionType: GET_AUDIT_LIST,
    data: { myAudit, type: props.type,documentId:props?.doumentId ? props?.doumentId :0},
  };
  const auditListActionPopoverDataUpdaterConfig = useMemo(() => {
    return {
      id: "pnlAuditListActionPopover",
      mdaeDataUpdaterConfig: [
        {
          actionType: TOGGLE_AUDIT_LIST_ACTION_POPOVER,
          reducerName: "auditListReducer",
          widgetOptionBindings: {
            target: "auditListDataGridActionPopoverTarget",
            visible: "isAuditListDataGridActionPopoverVisible",
          },
        },
      ],
    };
  }, []);

  const onAuditListCellPrepared = useCallback((e) => {
    if (e.rowType == "data") {
      $(e.cellElement).addClass("clickable-cell-cursor");
    }
  }, []);

  const isEMDRAttachContext = (props.type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE);
  const shouldHideCases = props.hideCases;

  return (
    <div className={"audit-list-content"}>
      {props.type?.toUpperCase() !== AUDIT_LIST_TYPE.EMDR_TYPE && (
        <MdaeActionPopover
          mdaePopoverConfig={auditListActionPopoverDataUpdaterConfig}
          menuItemListFunction={auditListActionPopoverMenuList}
        ></MdaeActionPopover>
      )}

      <div className="audit-list-container">
        <DataGridRecordsFilter
          id="pnlAuditsDataGridFilter"
          infoText="Audit list will display audits for the most recent month based on the number entered in the filter."
          titleText="Refresh Audit List"
          prefixText="Showing all audits from the past"
          suffixText="audit periods"
          rangeNumber={
            props.type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE ? 6 : 12
          }
          fetchOptions={dataGridRecordsFilterFetchOptions}
        />

        <div className="audit-list-grid-container">
          <MdaeDataGrid
            {...auditListDataGridOptions}
            mdaeDataGridCustomButtonsEnd={
              props.type?.toUpperCase() !== AUDIT_LIST_TYPE.EMDR_TYPE
                ? RenderToolbarButtonTemplate
                : (isEMDRAttachContext && !shouldHideCases)
                ? RendereMDRToolbarButtonTemplate
                : null
            }
            mdaeDataGridCustomButtonsBefore={
              (isEMDRAttachContext && !shouldHideCases)
                ? RenderExpandCollpaseButtonTemplate
                : null
            }
            onCellPrepared={onAuditListCellPrepared}
            onDataGridClearFilterClick={(e) => {
              if (isCaseLevelGridSearchEnabled) {
                dispatch(
                  resetDataGridFilter(
                    myAudit,
                    props?.type,
                    headerRangeFilterCount,
                    props.doumentId
                  )
                );
              }
              else{
                dispatch({
                  type: SET_LEVEL_GRID_SEARCH_ENABLED,
                  data: {
                    auditListSearchText: "",
                  },
                });
              }
            }}
          >
            {(isEMDRAttachContext && !shouldHideCases) && (
              <MasterDetail
                enabled={true}
                component={EMDRCaseList}
                autoExpandAll={true}
              />
            )}
            {!shouldHideCases &&
              isCaseLevelGridSearchEnabled &&
              isAuditWithCasesFetched && (
              <MasterDetail
                enabled={true}
                autoExpandAll={true}
                component={AuditWithCases}
              />
            )}
          </MdaeDataGrid>
          {!shouldHideCases && isCaseLevelGridSearchEnabled && (
            <>
              <CaseDetail
                auditGroupId={auditGroupId}
                eaRoundId={currentEaRoundId}
                caseMyTaskWidgetId={new Guid().toString()}
                caseMyPastDueTaskDrawerId={new Guid().toString()}
                caseMyThisWeekTaskDrawerId={new Guid().toString()}
                caseMyUpcomingTaskDrawerId={new Guid().toString()}
                caseMyCompletedTaskDrawerId={new Guid().toString()}
                isViewOnly={false}
                isHideBillingHistoryLink={false}
                isFromDenialPredictor={false}
                doNotLoadDatasourcesInd={false}
              ></CaseDetail>
            </>
          )}
        </div>
      </div>
      {props.type?.toUpperCase() !== AUDIT_LIST_TYPE.EMDR_TYPE &&
        isDocumentManagementPopupVisible && (
          <DocumentManagementPopup
            toggleDocumentManagementPopupVisible={
              toggleDocumentManagementPopupVisible
            }
          ></DocumentManagementPopup>
        )}
      {props.type?.toUpperCase() !== AUDIT_LIST_TYPE.EMDR_TYPE &&
        isReportPopupVisible &&
        currentUser?.userId > 0 &&
        getCurrentSelectedRowData() != null && (
          <ViewReport
            currentSelectedRowData={getCurrentSelectedRowData()}
            userId={currentUser?.userId}
          />
        )}
    </div>
  );
};

const enhance = compose(withRouter);

var lastClickTime = undefined;
var lastClickKey = undefined;

const getAuditListDataGridOptions = (
  props,
  dispatch,
  headerRangeFilterCount,
  isFromDashboardWidget,
  toggleActionPopover,
  myAudit,
  auditList,
  onInitialized,
  onDisposing,
  selectionAdjustingRef
) => {
  const sampleDataGridOption: IMdaeDataGridProps = {
    id: "pnlAuditList",
    mdaeColumnChooser: { isMdaeColumnChooserVisible: true },
    mdaeSearchPanel: { visible: true },
    clearFilterButtonId: "btn-audit-list-grid-clear-filter",
    export: {
      enabled:
        props.type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE ? false : true,
      fileName: "ExternalAuditsList",
    },
    headerFilter: {
      visible: true,
    },
    searchPanel: {
      visible: false,
    },
    selection: {
      mode: "multiple",
      showCheckBoxesMode: props.type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE ? "always" : "none",
      allowSelectAll: props.selectionModeOverride === "single" ? false : true,
    },
    onSelectionChanged: (e) => {
      if (!(props.selectionModeOverride === "single")) return;
      if (selectionAdjustingRef.current) return;

      const selectedKeys = e.selectedRowKeys;
      if (selectedKeys.length <= 1) return;

      const lastKey = selectedKeys[selectedKeys.length - 1];
      selectionAdjustingRef.current = true;
      e.component.deselectAll();
      e.component.option("selectedRowKeys", [lastKey]);
      selectionAdjustingRef.current = false;
    },
    allowColumnResizing: true,
    allowColumnReordering: true,
    groupPanel: {
      visible: props?.type?.toUpperCase() !== AUDIT_LIST_TYPE.EMDR_TYPE,
    },
    filterRow: {
      visible: true,
    },
    onInitialized: onInitialized,
    onDisposing: onDisposing,
    onToolbarPreparing: (e) => {
      e.toolbarOptions.elementAttr = {
        style: "height: 60px",
      };
    },
    mdaeStateStoring: {
      enabled: !isFromDashboardWidget,
      onBeforeLoadGridState: (state) => {
        if (state?.selectedRowKeys?.length > 0) {
          state.selectedRowKeys = [];
        }
         if (state?.searchText) {
          state.searchText ="";
        }
      },
      storageKey:
        props.type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE
          ? "allAuditListStorage"
          : myAudit == true
          ? "myAuditListStorage"
          : "allAuditListStorage",
    },
    dataSource: auditList,
    mdaeColumns: [
      {
        dataField: "",
        caption: "",
        alignment: "center",
        width: 40,
        allowExporting: false,
        visibleIndex: 1,
        fixed: true,
        cellRender: (e) => {
          if (e.data?.newRecordInd) {
            return (
              <div title="New billing data received">
                <i
                  className="fa fa-exclamation-triangle"
                  style={{ color: "orange" }}
                ></i>
              </div>
            );
          }
        },
      },
      {
        fixed: true,
        alignment: "center",
        visibleIndex: 0,
        cellRender: (e) => {
          return getDataGridActionEllipsisComponent(e, {
            showActionPopover: toggleActionPopover,
            entityName: "audit",
            entityId: e.data.eaAuditId,
            currentRowData: e.data,
            type: "usingDispatch",
            dispatch,
          });
        },
        width: 50,
      },
      { caption: "Title", dataField: "auditTitle", width: 200, fixed: true },
      { caption: "Audit Process Manager", dataField: "processManager", width: 150 },
      { caption: "Status", dataField: "auditStatus", width: 100 },
      { caption: "Open Task Count", dataField: "openTaskCount", width: 100 },
      {
        caption: "Overdue Task Count",
        dataField: "overdueTaskCount",
        width: 150,
      },
      { caption: "Process", dataField: "eaProcessTemplateName", width: 100 },
      {
        caption: "Source",
        dataField: "sourceName",
        width: 350,
      },
      {
        caption: "Requester- Initial",
        dataField: "initialRequester",
        width: 100,
      },
      {
        caption: "Requester- Current",
        dataField: "currentRequester",
        width: 100,
      },
      {
        caption: "Reference ID",
        dataField: "referenceId",
        width: 100,
      },
      {
        caption: "Notification Date",
        dataField: "notificationDate",
        dataType: "date",
        width: 120,
      },
      {
        caption: "Case Complete %",
        dataField: "caseCompletePercentage",
        width: 100,
      },
      { caption: "Audit Period", dataField: "auditPeriodName", width: 120 },
      {
        caption: "Claim Type",
        dataField: "claimType",
        width: 120,
        visible: false,
        cellTemplate: function(container, options) {
          const claimType = options.data.claimType;
          const isMatched = options.data.claimTypeCdMatched;
          const cellContent = $("<div>").text(claimType);
          if (isMatched) {
            cellContent.css("font-weight", "bold");
          }
          cellContent.appendTo(container);
        },
      },
      {
        caption: "Update Date",
        dataField: "updateDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
      { caption: "Updated By", dataField: "updatedBy", width: 120 },
      {
        caption: "Creation Date",
        dataField: "createDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
      },
      { caption: "Created By", dataField: "createdBy", width: 120 },
      {
        caption: "Start Date",
        dataField: "startDate",
        dataType: "date",
        format: "shortDate",
        width: 100,
        visible: false,
      },
      {
        caption: "Case Count",
        dataField: "caseCount",
        width: 120,
        visible: false,
      },
      {
        caption: "Audit Group",
        dataField: "auditGroupName",
        width: 120,
        visible: false,
      },
      {
        caption: "Audit ID",
        dataField: "eaAuditId",
        width: 100,
        visible: false,
      },
      {
        caption: "Current Round",
        dataField: "currentRound",
        width: 100,
        visible: false,
      },
      {
        caption: "Total At Risk $",
        dataField: "totalAtRiskDollars",
        width: 100,
        visible: false,
      },
      {
        caption: "Remaining $ in Review",
        dataField: "remainingDollarInReview",
        width: 100,
        visible: false,
      },
      {
        caption: "Total Refund $",
        dataField: "totalRefundedDollar",
        width: 100,
        visible: false,
      },
      {
        caption: "Additional Reimbursement",
        dataField: "additionalReimbursementDollars",
        width: 100,
        visible: false,
      },
      {
        caption: "Total Retained $",
        dataField: "totalRetainedDollar",
        width: 100,
        visible: false,
      },
    ],
    onRowDblClick: function(e) {
      if (e.rowType === "data") {
          props.history.push(
            "/externalaudit/audit?auditId=" + e.data?.eaAuditId
          );
      }
    },
    mdaeDataUpdaterConfig: [
      {
        actionType: SET_AUDIT_DATAGRID_FILTER,
        reducerName: "auditListReducer",
        widgetOptionBindings: {
          filterValue: "auditDataGridFilter",
        },
      },
    ],
  };
  if (props.type?.toUpperCase() === AUDIT_LIST_TYPE.EMDR_TYPE) {
    sampleDataGridOption.mdaeColumns.splice(0, 2);
  }
  return sampleDataGridOption;
};
const AuditWithCases = (props) => {
  return (
    <EACaseDetail
      {...props}
      hideSelection={true}
      type={AUDIT_LIST_TYPE.AUDIT_WITH_CASES}
    />
  );
};
const EMDRCaseList = (props) => {
  return (
    <EACaseDetail
      {...props}
      hideSelection={false}
      type={AUDIT_LIST_TYPE.EMDR_TYPE}
    />
  );
};
export default enhance(AuditList) as any;



